import { isWithinInterval } from '@e3dc-react/shell/Libs/date'
import { DynamicPrices } from '../models/tariffs-model'

/**
 * Function for calculating current dynamic prices
 *  - dynamic prices are different per each hour.
 *  - FE calculates if present moment is in range of date and hour of provided prices and display that price as valid
 * @param data - array of DynamicPrices
 * @returns - gird price as number or string, solar price as number or string, or undefined object
 */
export const getCurrentDynamicPrices = (dynamicPrices: DynamicPrices[]): { gridPrice: number; solarPrice: number } | undefined => {
  const currentTariff = dynamicPrices.find(price => {
    const validTariff = isWithinInterval(new Date(), {
      start: new Date(price.startDateTime ?? 0),
      end: new Date(price.endDateTime ?? 0),
    })
    return validTariff
  })

  return (
    currentTariff && {
      gridPrice: currentTariff.gridPrice,
      solarPrice: currentTariff.solarPrice,
    }
  )
}
